import { withStyles } from '@material-ui/core/styles';
import CustomTablePagination from './CustomTablePagination';
import styles from './styles';

export default withStyles(styles)(CustomTablePagination);
